import {
  VERIFY_USER_FEATURE_KEY,
  VerifyUserState,
} from './verify-user.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

// Lookup the 'VerifyUser' feature state managed by NgRx
export const getVerifyUserState = createFeatureSelector<VerifyUserState>(
  VERIFY_USER_FEATURE_KEY,
);

export const isVerifying = createSelector(
  getVerifyUserState,
  (state: VerifyUserState) => state.verifying,
);

export const getVerifyUserError = createSelector(
  getVerifyUserState,
  (state: VerifyUserState) => state.error,
);
